import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Button } from "../Button";
import styles from "./ContainerHeader.module.scss";
export const ContainerHeader = ({ ctaHref, ctaLabel, title }) => {
    const buttonCommonProps = {
        href: ctaHref,
        variant: "redirect",
        color: "secondary",
    };
    const isTitleHidden = !title;
    const isLinkHidden = !ctaHref || !ctaLabel;
    if (isTitleHidden && isLinkHidden) {
        return null;
    }
    return (_jsxs("div", { className: classNames(styles.headingWrapper, {
            [styles.withLinkOnly]: isTitleHidden,
        }), children: [!isTitleHidden && _jsx("span", { className: styles.title, children: title }), !isLinkHidden && (_jsxs("div", { className: classNames(styles.buttonWrapper, {
                    [styles.positionReset]: isTitleHidden,
                }), children: [_jsx(Button, { ...buttonCommonProps, className: styles.desktopButton, size: "large", children: ctaLabel }), _jsx(Button, { ...buttonCommonProps, className: styles.mobileButton, size: "small", children: ctaLabel })] }))] }));
};
//# sourceMappingURL=ContainerHeader.js.map